<template>
  <div class="popup_content">
    <v-popuptitle message="안내" imgsrc="sub/ic_popup.png"></v-popuptitle>
    <div class="popup__con_inner tac">
      <div class="popup__item">
        <div class="popup__box" style="text-align: left; padding: 20px">
          <p class="popup__sub">
            5월 12일 오후 6시 학생 목록 관련 수정 사항을 배포하였으나
            <br />
            오류가 생겨 일시적으로 병원 계정에서의 학생 목록 노출이 누락되었습니다.
            <br />
            <br />
            현재는 오류 파악하여 긴급 배포를 진행하였고 학생 목록 확인이 가능합니다.
            <br />
            불편을 드려 죄송합니다.
            <br />
            <br />
            해당 오류 관련하여 추가 문의가 있을 경우
            <br />
            하단의 채팅 상담하기를 통해 문의주시면 빠르게 처리 도와드리겠습니다.
          </p>
        </div>
      </div>
      <div class="popup__close">
        <a href="javascript:;" style="background-color: #f0f0f0; color: #737373" @click="todayClose()">다시 보지 않기</a>
        <a href="javascript:;" @click="popupClose()">닫기</a>
      </div>
    </div>
  </div>
</template>

<script>
import popupTitle from '@/components/popup/PopupTitle.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    'v-popuptitle': popupTitle,
  },
  computed: {
    ...mapState('user', ['userOrganTargetType']),
    ...mapState('status', ['userOrganTargetTypeToPath']),
  },
  methods: {
    ...mapActions('popup', ['todayClose', 'popupClose']),
  },
};
</script>

<style scoped>
.popup__item {
  padding: 7px 80px 30px 80px;
}
.popup__box {
  padding: 30px 0;
  background: #fff;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  text-align: center;
}
.popup__text {
  line-height: 30px;
  font-size: 21px;
  font-weight: 700;
  color: #1c1c1c;
}
.popup__sub {
  line-height: 23px;
  font-size: 16px;
  color: #191919;
}
.popup__info {
  padding: 0 50px;
}
.popup__info table {
  border: 1px solid #cacaca;
}
.popup__info th,
.popup__info td {
  padding: 4px 13px;
  border-left: 1px solid #cacaca;
  line-height: 20px;
  font-size: 14px;
  color: #191919;
}
.popup__info th {
  font-weight: 700;
}
.popup__info td {
  text-align: left;
  font-weight: 400;
  letter-spacing: -0.5px;
}
.popup__info thead th {
  background-color: #f0f0f0;
}
.popup__info tbody th,
.popup__info tbody td {
  border-top: 1px solid #cacaca;
}
.popup__sm__text {
  font-size: 14px;
}
.popup__close {
  float: right;
  margin-right: 10px;
}
.popup__close a {
  padding: 10px 25px;
  margin-right: 10px;
  background-color: #0f6af0;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: white;
  vertical-align: middle;
}
</style>
